<h3 mat-dialog-title>Transaction Details</h3>

<mat-dialog-content>

    <div class="d-loading my-4 py-4" *ngIf="loading">
        <div class="loader">Loading ...</div>
    </div>

    <ng-container *ngIf="!loading">
        <div class="d-flex justify-content-between mt-2">
            <div>
                Status
            </div>
            <div class="d-flex justify-content-end">
                <span *ngIf="data.transaction.bankReconciliationTransaction" class="status-pill status-approved">Reconciled</span>
                <span *ngIf="data.transaction.approved" class="status-pill status-approved">Approved</span>
                <span *ngIf="data.transaction.excluded" class="status-pill status-excluded">Excluded</span>
                <span *ngIf="!data.transaction.approved && !data.transaction.excluded" class="status-pill status-pending">Pending Review</span>
            </div>
        </div>

        <div class="d-flex justify-content-between mt-2">
            <div>
                Date
            </div>
            <div class="d-flex justify-content-end">
                {{ data.transaction.transactionDate | legfiDate }}
            </div>
        </div>

        <div class="d-flex justify-content-between mt-2">
            <div>
                Amount
            </div>
            <div class="d-flex justify-content-end" [innerHTML]="data.transaction.amount | legfiBalance">
            </div>
        </div>

        <div class="d-flex justify-content-between mt-2" *ngIf="data.transaction.owner">
            <div>
                Account
            </div>
            <div class="d-flex justify-content-end">
                {{ data.transaction.owner.friendlyName }}
            </div>
        </div>

        <div class="d-flex justify-content-between mt-2" *ngIf="data.transaction.category">
            <div>
                Category
            </div>
            <div class="d-flex justify-content-end">
                {{ data.transaction.category.name }}
            </div>
        </div>

        <hr/>

        <ng-container *ngIf="data.transaction.isPayable">
            <app-payable-details [transaction]="data.transaction"></app-payable-details>
        </ng-container>
        
        <ng-container *ngIf="!data.transaction.isPayable">
            <div class="d-flex flex-column mt-2">
                <label>
                    Description
                </label>
                <div class="wrap">
                    {{ data.transaction.description }}
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="data.transaction.journalEntry">
            <hr/>
            <div class="d-flex flex-column mt-2">
                <label>
                    Journal Entry Details
                </label>
                <div class="grid-layout grid-2 mt-0">
                    <div class="d-flex flex-column">
                        <label>Debits</label>
                        <ng-container *ngFor="let entry of (data.transaction.journalEntries | whereIn:['debit']:'type'); trackBy: trackByIndex">
                            <div class="d-flex justify-content-between">
                                <div>{{ entry.class.label }}</div>
                                <div class="d-flex justify-content-end">{{ entry.amount | legfiCurrency }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="d-flex flex-column">
                        <label>Credits</label>
                        <ng-container *ngFor="let entry of (data.transaction.journalEntries | whereIn:['credit']:'type'); trackBy: trackByIndex">
                            <div class="d-flex justify-content-between">
                                <div>{{ entry.class.label }}</div>
                                <div class="d-flex justify-content-end">{{ entry.amount | legfiCurrency }}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="data.transaction.attachments.length > 0">
            <hr/>
            <div class="d-flex flex-column mt-2">
                <label>
                    Attachments
                </label>

                <ng-container *ngFor="let attachment of data.transaction.attachments; trackBy: trackByIndex">
                    <div class="d-flex justify-content-between">
                        <div>
                            <a [href]="'/organizations/'+data.transaction.organizationId+'/transactions/'+data.transaction.id+'/attachments/'+attachment.id | coreUrl" target="_blank" rel="noopener">{{ attachment.filename }}</a>
                        </div>
                        <div class="d-flex justify-content-end">
                            <span>{{ attachment.filesize }}</span>
                        </div>
                    </div>
                </ng-container>

            </div>
        </ng-container>

        <ng-container *ngIf="data.transaction.children.length > 0">
            <hr/>
            <div class="d-flex flex-column mt-2">
                <label>
                    Transaction Details
                </label>

                <mat-accordion>
                    <ng-container *ngFor="let child of data.transaction.children; trackBy: trackByIndex">
                        <mat-expansion-panel hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title> {{ child.description }}</mat-panel-title>
                                <mat-panel-description class="d-flex justify-content-end flex-grow-0">
                                    <span [innerHTML]="getChildDisplayAmount(child) | legfiBalance"></span>
                                </mat-panel-description>
                            </mat-expansion-panel-header>

                            <div class="grid-layout grid-2 mt-0">
                                <div>
                                    <label>Payment Date</label>
                                    <div>{{ child.transactionDate | legfiDate }}</div>
                                </div>
                                <div>
                                    <label>Payment Method</label>
                                    <div>
                                        <div>{{ (child.reference | as:PaymentAttempt).paymentGroup.friendlyPaymentMethod }}</div>
                                    </div>
                                </div>
                                <div>
                                    <label>Payment Amount</label>
                                    <div>{{ (child.reference | as:PaymentAttempt).gross | legfiCurrency }}</div>
                                </div>
                                <div>
                                    <label>Net</label>
                                    <div>{{ (child.reference | as:PaymentAttempt).net | legfiCurrency }}</div>
                                </div>
                                <div>
                                    <label>Confirmation Number</label>
                                    <div>{{ (child.reference | as:PaymentAttempt).confirmationNumber }}</div>
                                </div>
                            </div>


                            <label>Charges Paid</label>

                            <mat-table [dataSource]="child.children">

                                <ng-container matColumnDef="charge">
                                    <mat-header-cell *matHeaderCellDef> Charge</mat-header-cell>
                                    <mat-cell *matCellDef="let row"> {{ row.description }}</mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="amount">
                                    <mat-header-cell *matHeaderCellDef> Amount</mat-header-cell>
                                    <mat-cell *matCellDef="let row" [innerHTML]="row.amount | legfiBalance"></mat-cell>
                                </ng-container>

                                <ng-container matColumnDef="category">
                                    <mat-header-cell *matHeaderCellDef> Category</mat-header-cell>
                                    <mat-cell *matCellDef="let row"> {{ row.category?.name }}</mat-cell>
                                </ng-container>

                                <mat-header-row *matHeaderRowDef="['charge', 'amount', 'category']"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: ['charge', 'amount', 'category'];"></mat-row>

                            </mat-table>

                        </mat-expansion-panel>
                    </ng-container>
                </mat-accordion>

            </div>
        </ng-container>

        <div class="card mt-4" *ngIf="hasAccountingV2 && jwt.admin && data.transaction?.ledgerEntries?.length">
            <div class="card-header d-flex justify-content-between">
                <h2>Ledger Entries</h2>
            </div>
            <div class="card-body p-0">
                <table class="table m-0">
                    <thead>
                    <tr>
                        <th>Entry Date</th>
                        <th>Account</th>
                        <th class="text-right">Debit</th>
                        <th class="text-right">Credit</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!--suppress HtmlUnknownAttribute -->
                    <ng-template [ngForOf]="data.transaction.ledgerEntries | groupBy:'batchId'" let-group ngFor>
                        <tr>
                            <td colspan="2" matTooltip="Created {{group[0].createdAt | legfiDate}}">
                                {{ group[0].description }}
                            </td>
                            <td colspan="2" class="text-right">
                                <button class="btn btn-link p-0 m-0" *ngIf="jwt.superUser" (click)="deleteLedgerBatch(group[0].batchId)">
                                    Delete Batch
                                    <app-super-star></app-super-star>
                                </button>
                            </td>
                        </tr>
                        <ng-template [ngForOf]="group" let-item ngFor>
                            <!--suppress HtmlUnknownAttribute -->
                            <tr>
                                <td>
                                    {{ item.entryDate | legfiDate }}
                                </td>
                                <td>
                                    {{ item.account?.name }}
                                </td>
                                <td class="text-right">
                                    {{ item.debit | legfiCurrency }}
                                </td>
                                <td class="text-right">
                                    {{ item.credit | legfiCurrency }}
                                </td>
                            </tr>
                        </ng-template>
                    </ng-template>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th>Total</th>
                        <th></th>
                        <th class="text-right">{{ data.transaction.ledgerEntries | sum:'debit' | legfiCurrency }}</th>
                        <th class="text-right">{{ data.transaction.ledgerEntries | sum:'credit' | legfiCurrency }}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>


    </ng-container>

</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-outline-secondary" mat-dialog-close>Close</button>
</mat-dialog-actions>

